export default {
  apiKey: 'AIzaSyAaZl_yJvUuE-AWeooKgXGhgfO-bpvta4g',
  authDomain: 'monitoring.mirenco.com',
  projectId: 'mirenco',
  storageBucket: 'mirenco.appspot.com',
  messagingSenderId: '371954605197',
  appId: '1:371954605197:web:71f4d52e10aa6a6d2e96c4',
};
